<template>
  <div class="main">
    <div
      class="top_txt"
      v-for="(item, index) in programas"
      v-if="item.id == items_tit_id"
    >
      {{ item.name }}
    </div>
    <!-- 频道列表 -->
    <div class="case_main">
      <ul v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <li v-for="item in list.case.caselist">
          <router-link to="" tag="a" @click.native="caseid(item.id)">
            <div class="list_main">
              <img :src="item.img" />
            </div>

            <div class="case_word">
              <h4 class="f14" v-html="item.name"></h4>
              <p class="col_6 f12" v-html="item.scene"></p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>

    <div class="loding" v-if="list.loading">
      <i class="el-icon-loading"></i>
      <p class="el-loading-text f12">加载中</p>
    </div>
    <div class="loding" v-if="noMore">
      <p class="el-loading-text f12">没有更多了</p>
    </div>
  </div>
</template>

<script>
import wxapi from "../../public/wxapi.js";
export default {
  data() {
    return {
      programas: [],
      items_tit: "",
      items_tit_id: "1",
      list: {
        loading: false,
        kind: "3", //选择栏目index
        page: 4,

        menu: {
          title: "",
          background: "",
          menulist: [
            {
              id: "",
              img: "",
              intro: ""
            }
          ]
        },
        case: {
          sum: 0,
          caselist: []
        }
      }
    };
  },
  methods: {
    wxRegCallback() {
      // 用于微信JS-SDK回调
      this.wxShareTimeline();
      this.wxShareAppMessage();
    },
    wxShareTimeline() {
      // 微信自定义分享到朋友圈
      let option = {
        title: this.programas[this.$route.params.id.split(".")[0]-2].name, // 分享标题, 请自行替换
        desc: "石家庄飞天科技开发有限公司", // 分享描述, 请自行替换
        link: window.location.href, // 分享链接，根据自身项目决定是否需要split
        success: () => {
          // alert("分享成功");
        },
        error: () => {
          // alert("已取消分享");
        }
      };
      // 将配置注入通用方法
      wxapi.ShareTimeline(option);
    },
    wxShareAppMessage() {
      // 微信自定义分享给朋友
      let option = {
        title: this.programas[this.$route.params.id.split(".")[0]-2].name, // 分享标题, 请自行替换
        desc: "石家庄飞天科技开发有限公司", // 分享描述, 请自行替换
        link: window.location.href, // 分享链接，根据自身项目决定是否需要split
        success: () => {
          // alert("分享成功");
        },
        error: () => {
          // alert("已取消分享");
        }
      };
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option);
    },
    load() {
      this.list.loading = true;
      setTimeout(async () => {
        var dt = await this.$axios.post("/api/itemmore", {
          menu: this.list.kind,
          amount: 3,
          type: 1,
          page: this.list.page + 1
        });
        dt.data = JSON.parse(dt.data);
        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: "info",
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText);
          return;
        }

        for (var i = 0; i < dt.data.data.data.length; i++) {
          this.list.case.caselist.push(dt.data.data.data[i]);
        }
        this.list.page = dt.data.data.page;
        console.log(this.list.case.sum);
        console.log(dt);
        this.list.loading = false;
      }, 1000);
    },

    //获取初始数据
    async getcase(val) {
      var dt = await this.$axios.post("/api/items", {
        menu: val
      });
      dt.data = JSON.parse(dt.data);
      if (dt.status == 200) {
        if (dt.data.code !== 0) {
          this.$message({
            type: "info",
            message: dt.data.msg
          });
          return;
        }
      } else {
        alert(dt.statusText);
        return;
      }
      // console.log(dt.data.data)
      this.list.case.caselist = dt.data.data.case.caselist;
      this.list.case.sum = dt.data.data.case.sum;
    },

    async gettit(val) {
      this.items_tit_id = val.split("html");
      this.items_tit_id = this.items_tit_id[0];
      // console.log(this.items_tit_id)
      var dt = await this.$axios.get("/api/header");
      dt.data = JSON.parse(dt.data);
      if (dt.status == 200) {
        if (dt.data.code !== 0) {
          this.$message({
            type: "info",
            message: dt.data.msg
          });
          return;
        }
      } else {
        alert(dt.statusText);
        return;
      }
      // console.log(dt.data.data.programas)
      this.programas = dt.data.data.programas;
      // console.log(this.programas)
       wxapi.wxRegister(this.wxRegCallback);

    },

    // 案例详情页
    caseid(val) {
      this.$router.push({
        name: "medetails",
        params: {
          id: val + ".html"
        }
      });
    }
  },
  created() {
    // console.log(this.$route.params.id)
    // console.log(this.$route.params.id.split('.')[0])
    // console.log(this.$route.params.items_tit_id)
    this.getcase(this.$route.params.id.split(".")[0]);
    this.list.kind = this.$route.params.id.split(".")[0];
    this.gettit(this.$route.params.id.split(".")[0]);
  },
  mounted() {
    
  },
  computed: {
    noMore() {
      // console.log( this.list.case.sum)
      // console.log( this.list.case.caselist.length)
      return this.list.case.caselist.length >= this.list.case.sum;
    },
    disabled() {
      return this.list.loading || this.noMore;
    }
  },
  // updated:function(){
  //      window.scroll(0, 0);
  //     },
  watch: {
    $route(to, from) {
      this.liston(this.$route.params.id.split(".")[0]);
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  /deep/.van-tabs {
    .van-tab {
      padding: 0;
    }
    .van-tabs__line {
      display: none;
    }
    .van-tab {
      line-height: 55px;
      height: 55px;
    }
    .van-tab--active {
      font-size: 16px;
      font-weight: 600;
    }
    .van-tabs__nav {
      background-color: #f5f5f5;
      padding-bottom: 0;
      height: 55px;
    }

    .van-tabs__wrap {
      position: fixed;
      top: 0;
      z-index: 2;
      left: 0;
      right: 0;
      height: 55px;
      padding: 0 10px;
      max-width: 620px;
    }
  }

  .navlist {
    ul {
      overflow: hidden;
      line-height: 60px;
      li {
        float: left;
        width: 25%;
        text-align: center;
        color: #797880;
      }
      .active {
        color: #e50012;
        font-size: 18px;
      }
    }
  }
  .top_txt {
    text-align: center;
    padding: 20px 0;
    font-size: 24px;
    color: #333;
    position: relative;
  }

  .top_txt:before {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 5px;
    display: block;
    width: 64px;
    height: 3px;
    background: #e50012;
    margin-left: -32px;
  }

  .case_main {
    ul {
      overflow: hidden;
      margin: 5px;
      /* background:url(../../assets/images/successfulcase.jpg); */

      li {
        box-shadow: 0 2px 5px 0 #eaeaea;
        width: 48%;
        overflow: hidden;
        float: left;
        border-radius: 5px;
        box-sizing: border-box;
        margin: 1%;

        @media (max-width: 480px) {
          .list_main {
            height: 120px;
          }
        }

        @media (min-width: 480px) and (max-width: 2000px) {
          .list_main {
            height: 200px;
          }
        }

        .list_main {
          overflow: hidden;
          box-sizing: border-box;
          background: #fff;
          opacity: 0.9;
          position: relative;
          /* border:4px solid #dbdbdb; */
          border-radius: 5px;

          img {
            width: 100%;
          }

          .hover {
            width: 100%;
            height: 30px;
            position: absolute;
            bottom: 0;
            left: 0;
            opacity: 0.8;
            background: #ccc;
          }
        }

        .case_word {
          min-height: 80px;
          text-align: left;
          padding: 5px 10px;
          overflow-y: hidden;
          box-sizing: border-box;
          background: #fff;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;

          h4 {
            font-weight: bold;
            line-height: 20px;
            height: 40px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          p {
            white-space: nowrap;
            overflow: hidden;
            padding: 5px 0;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .loding {
    text-align: center;
    color: #999;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/move/items.vue